import type { TrackingData } from "../types/tracking";
import { TrackSessionStart } from "./SessionStart";
import { EmptyStateTime, SuggestRenderTime } from "../times";
import { CookieBanner } from "../helper";
import { SAN_SEARCH_TYPE, TRACK_LABEL } from "../types/constants";
import { TrackingEvent } from "../events";
import { SanSearchHistory } from "../types/tracking/constants";

/**
 *
 *
 */

export function updateSearchType(
  currentSearchType: SAN_SEARCH_TYPE,
  isModifiedSearch: boolean,
  isTrackSuggest: boolean,
  isEmptyState: boolean,
  isHistorySuggest: boolean,
  hasHistoryFilters: boolean,
): SAN_SEARCH_TYPE {
  if (isModifiedSearch) {
    return SAN_SEARCH_TYPE.MODIFIED;
  }
  if (isTrackSuggest) {
    if (isEmptyState) {
      return SAN_SEARCH_TYPE.EMPTY_STATE;
    } else {
      return SAN_SEARCH_TYPE.SUGGEST;
    }
  }
  if (isHistorySuggest) {
    if (hasHistoryFilters) {
      return SAN_SEARCH_TYPE.HISTORY_FILTER;
    }
    return SAN_SEARCH_TYPE.HISTORY;
  }
  return currentSearchType || SAN_SEARCH_TYPE.NONE;
}

function trackUsage(
  extendByParameters: TrackingData,
  extendByHashParameters: TrackingData,
  isModifiedSearch: boolean,
  isTrackSuggest: boolean,
  isEmptyState: boolean,
  isHistorySuggest: boolean,
  hasHistoryFilters: boolean = false,
) {
  const jsonForTracking: TrackingData = { ...extendByParameters, ...extendByHashParameters };

  jsonForTracking[TRACK_LABEL.WK_SEARCH_TYPE] = updateSearchType(
    jsonForTracking[TRACK_LABEL.WK_SEARCH_TYPE] as SAN_SEARCH_TYPE,
    isModifiedSearch,
    isTrackSuggest,
    isEmptyState,
    isHistorySuggest,
    hasHistoryFilters,
  );

  if (CookieBanner.isEnabled()) {
    jsonForTracking[TRACK_LABEL.WK_INITIAL_SEARCHBOX_TIME] = TrackSessionStart.updateLabel();
  }

  if (isEmptyState) {
    EmptyStateTime.measure();
    jsonForTracking[TRACK_LABEL.WK_EMPTY_STATE_TIME] = EmptyStateTime.timeTotal;
    jsonForTracking[TRACK_LABEL.WK_EMPTY_STATE_COUNT] = EmptyStateTime.countMarks;
  }

  jsonForTracking[TRACK_LABEL.SUGGEST_RENDER_TIME] = SuggestRenderTime.timeAverage;

  if (isEmptyState && !window.o_squirrel.submitHistory.isEmpty()) {
    /*                                 */
    jsonForTracking.san_SuggestList = jsonForTracking.san_SuggestList?.split("|").slice(0, 5).join("|");
    jsonForTracking.san_SuggestListWordCount = jsonForTracking.san_SuggestListWordCount
      ?.split("|")
      .slice(0, 5)
      .join("|");
  }

  if (jsonForTracking[TRACK_LABEL.WK_SEARCH_HISTORY]) {
    jsonForTracking[TRACK_LABEL.WK_SEARCH_HISTORY] = window.o_squirrel.submitHistory.filterExists()
      ? SanSearchHistory.FILTER
      : SanSearchHistory.EXISTS;
  }

  TrackingEvent.trackOnNextPageImpression(jsonForTracking);
}

/**
 *
 *
 *
 *
 */
function markFormForTracking(marker: string, searchForm: HTMLFormElement) {
  searchForm.classList.add(marker);
}

/**
 *
 *
 *
 *
 */
function unmarkFormForTracking(marker: string, searchForm: HTMLFormElement) {
  searchForm.classList.remove(marker);
}

export const suggestTracking = {
  unmarkFormForTracking,
  markFormForTracking,
  trackUsage,
};
